export const workshops = ['Kalmar', 'Nässjö']
